import type { BrandName } from '@/scopes/common/domain/types'

export function shouldShowGoodToKnowAfterAccommodationDescription(brandName: BrandName): boolean {
  return isElizaBrand(brandName)
}

export function shouldShowCarRentalInformation(brandName: BrandName): boolean {
  return isElizaBrand(brandName)
}

function isElizaBrand(brandName: BrandName): boolean {
  return brandName === 'eliza'
}
